<!-- <p>blog works!</p> -->
<iframe
[src]="fileSrc"
frameborder="0"

></iframe>